import { useContext } from "react";
import { ConfigContext } from "../providers/ConfigContext";
import useMakeApiRequest from "./useMakeApiRequest";

const useSendEmail = () => {
  const { apiBase } = useContext(ConfigContext);
  const makeApiRequest = useMakeApiRequest("POST");

  const sendEmail = async (transactionId: any, body: any) => await makeApiRequest(`${apiBase}/api/transactions/${transactionId}/email`, body);

  return [sendEmail];
};

export default useSendEmail;
